import Employee from '../model/product/employee';
import { Tour } from '../model/tour/tour';
import DateHelper from './date-helper';

export class TourHelper {
  private constructor() {}

  public static readonly EMPTY_TOUR: Tour = new Tour();

  static getTourDateDisplay(tourItem: TourItemLike): string {
    if (tourItem == null || tourItem.tour == null) {
      return null;
    }
    return DateHelper.formatDate(tourItem.tour.date);
  }
}

interface TourItemLike {
  tour: TourLike;
}

interface TourLike {
  date: Date;

  placer: Employee;
}
